import React from "react";

import Index from "./Reservation/Index";
import Success from "./Reservation/Success";

const Reservation = ({ ssr, action, isAppWebView }) => {
  const comp = {
    Index: Index,
    Success: Success,
  };
  const Component = comp[action];
  return <Component page={ssr.result} isAppWebView={isAppWebView}></Component>;
};

export default Reservation;
